import { isInterday } from '../../events/functions/event-status'
import { LiveEvent } from '@flocasts/flosports30-types/dist/entity'
import { LiveEventStatus } from 'src/app/events/events.enum'

export type LiveEventDescriptionDeps = Pick<
  LiveEvent,
  'title' | 'start_date_time' | 'status' | 'start_at_next' | 'start_time'
>

export function makeLiveEventDescription(e: LiveEventDescriptionDeps, verticalName: string) {
  if (
    [LiveEventStatus.Live, LiveEventStatus.Interday, LiveEventStatus.Intermission].includes(
      e.status as LiveEventStatus
    ) ||
    isInterday(e.start_at_next, e.status, e.start_time)
  ) {
    return (
      `Live! Stream ${e.title} on ${verticalName}. Watch on your computer, ` +
      'the FloSports Mobile App, your Smart TV, Roku or FireStick.'
    )
  }

  if (e.status === LiveEventStatus.PreAir) {
    return (
      `Stream ${e.title} live, starting at ${e.start_date_time} ` +
      `on ${verticalName}. Watch on your computer, on the FloSports ` +
      'Mobile App, your Smart TV, Roku or FireStick.'
    )
  }

  return (
    `Watch replays and highlights from ${e.title} on ` +
    `${verticalName}. Watch on your computer, on the FloSports Mobile ` +
    'App, your Smart TV, Roku or FireStick.'
  )
}

export function getLiveSiteTitle(liveEvent: LiveEvent | undefined, isGeoBlocked?: boolean): string | undefined {
  if (!liveEvent || !liveEvent.title) return undefined
  const title = isGeoBlocked
    ? `${liveEvent.short_title || liveEvent.title} is not available in your location`
    : `Stream ${liveEvent.short_title || liveEvent.title}`

  return title
}
